import en from './en';
import bs from './bs';
import hr from './hr';
import srLatn from './srLatn';
import srCyrl from './srCyrl';

const translations = {
  en, bs, hr, srLatn, srCyrl,
};
const loadTranslations = (lang) => translations[lang];

export {
  loadTranslations, en, bs, hr, srLatn, srCyrl,
};
